import React, { useEffect, useState } from "react";
import { Form, Input, Checkbox, Button, message } from "antd";
import "./AdminRehabCenterEditor.css";

const AdminRehabCenterEditor = ({ data, onCancel, onSubmit }) => {
  const [form] = Form.useForm();
  const [changedFields, setChangedFields] = useState({});

  useEffect(() => {
    if (data) {
      form.setFieldsValue({
        name: data.name,
        email: data.email,
        license_number: data.license_number,
        phone_country_code: data.phone_country_code,
        phone_number: data.phone_number,
        whatsapp_country_code: data.whatsapp_country_code,
        whatsapp_number: data.whatsapp_number,
        pincode: data.pincode,
        services: data.services,
        order_methods: data.order_methods,
        address_line1: data.address_line1,
        locality: data.locality,
        city_town: data.city_town,
        district: data.district,
        state: data.state,
        google_maps_link: data.google_maps_link,
        is_open_24_hours: !!data.is_open_24_hours,
        open_from: data.open_from,
        open_to: data.open_to,
      });
      setChangedFields({});
    }
  }, [data, form]);

  const handleFinish = async (values) => {
    try {
      await onSubmit({ id: data.id, ...values });
      message.success("Rehab center updated successfully");
      onCancel();
    } catch (err) {
      message.error("Failed to update rehab center");
    }
  };

  const handleValuesChange = (changedValues, allValues) => {
    const newChangedFields = { ...changedFields };
    for (const key in changedValues) {
      if (data[key] !== allValues[key]) {
        newChangedFields[key] = true;
      } else {
        delete newChangedFields[key];
      }
    }
    setChangedFields(newChangedFields);
  };

  return (
    <div>
      <Form
        layout="vertical"
        form={form}
        onFinish={handleFinish}
        onValuesChange={handleValuesChange}
      >
        <Form.Item
          label="Name"
          name="name"
          rules={[{ required: true }]}
          className={changedFields.name ? "edited-field" : ""}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Email"
          name="email"
          rules={[{ required: true, type: "email" }]}
          className={changedFields.email ? "edited-field" : ""}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="License Number"
          name="license_number"
          className={changedFields.license_number ? "edited-field" : ""}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Phone Number"
          name="phone_number"
          className={changedFields.phone_number ? "edited-field" : ""}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="WhatsApp Number"
          name="whatsapp_number"
          className={changedFields.whatsapp_number ? "edited-field" : ""}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Pincode"
          name="pincode"
          className={changedFields.pincode ? "edited-field" : ""}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Services Offered"
          name="services"
          className={changedFields.services ? "edited-field" : ""}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Order Methods"
          name="order_methods"
          className={changedFields.order_methods ? "edited-field" : ""}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Address Line 1"
          name="address_line1"
          className={changedFields.address_line1 ? "edited-field" : ""}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Locality"
          name="locality"
          className={changedFields.locality ? "edited-field" : ""}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="City/Town"
          name="city_town"
          className={changedFields.city_town ? "edited-field" : ""}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="District"
          name="district"
          className={changedFields.district ? "edited-field" : ""}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="State"
          name="state"
          className={changedFields.state ? "edited-field" : ""}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Google Maps Link"
          name="google_maps_link"
          className={changedFields.google_maps_link ? "edited-field" : ""}
        >
          <Input />
        </Form.Item>

        <Form.Item
          name="is_open_24_hours"
          valuePropName="checked"
          className={changedFields.is_open_24_hours ? "edited-field" : ""}
        >
          <Checkbox>Open 24 Hours</Checkbox>
        </Form.Item>

        <Form.Item
          noStyle
          shouldUpdate={(prev, cur) =>
            prev.is_open_24_hours !== cur.is_open_24_hours
          }
        >
          {({ getFieldValue }) => {
            return !getFieldValue("is_open_24_hours") ? (
              <>
                <Form.Item
                  label="Open From"
                  name="open_from"
                  className={changedFields.open_from ? "edited-field" : ""}
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  label="Open To"
                  name="open_to"
                  className={changedFields.open_to ? "edited-field" : ""}
                >
                  <Input />
                </Form.Item>
              </>
            ) : null;
          }}
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit" block>
            Update Rehab Center
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default AdminRehabCenterEditor;